module.exports = __webpack_public_path__ + "static/media/background-test.516e2261.jpg";